export default function Privacy() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-16 prose prose-invert">
      <h1 className="text-3xl md:text-4xl font-bold">Privacy Policy</h1>
      <p className="text-sm text-slate-500">Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>

      <Section title="What we collect">
        <p>To run DraftLion, we collect:</p>
        <ul className="mt-2 list-disc list-inside text-slate-300 space-y-1">
          <li><strong>Email address</strong> — for delivering your API key and account communications</li>
          <li><strong>Payment information</strong> — handled entirely by Stripe; we never see or store your card details</li>
          <li><strong>API usage logs</strong> — request timestamps and tool names called by your API key, for rate limiting and abuse prevention. Retained 30 days.</li>
          <li><strong>Sleeper data you ask about</strong> — usernames, league IDs, draft IDs you give to Claude. Cached briefly (under 30 seconds) to reduce load on Sleeper's API. Not stored long-term.</li>
        </ul>
      </Section>

      <Section title="What we don't collect">
        <ul className="mt-2 list-disc list-inside text-slate-300 space-y-1">
          <li>Your conversations with Claude</li>
          <li>Other tabs you have open</li>
          <li>Personal browsing data</li>
          <li>Anything beyond what's needed to operate the service</li>
        </ul>
      </Section>

      <Section title="Third parties">
        <p>We share data with these services because they make DraftLion possible:</p>
        <ul className="mt-2 list-disc list-inside text-slate-300 space-y-1">
          <li><strong>Stripe</strong> — payment processing. <a className="text-amber-400 hover:text-amber-300" href="https://stripe.com/privacy" target="_blank" rel="noopener">Stripe's privacy policy</a></li>
          <li><strong>AWS</strong> — hosting. Your data lives in AWS US-East-1.</li>
          <li><strong>Sleeper</strong> — fantasy football data. We call Sleeper's public API on your behalf. We don't share your email or payment info with them.</li>
        </ul>
      </Section>

      <Section title="Your rights">
        <p>
          You can request a copy of your data, deletion of your account, or correction of any
          information by emailing <a className="text-amber-400 hover:text-amber-300" href="mailto:support@thedraftlion.com">support@thedraftlion.com</a>.
          We respond within 30 days.
        </p>
      </Section>

      <Section title="Cookies">
        <p>
          DraftLion uses no cookies and no tracking pixels on this site. Stripe Checkout
          (a separate page you're sent to during purchase) uses its own cookies to process payment.
        </p>
      </Section>

      <Section title="Changes to this policy">
        <p>
          If we ever change how we handle your data, we'll update this page and email
          customers with active subscriptions before the changes take effect.
        </p>
      </Section>

      <Section title="Contact">
        <p>
          Questions? Email <a className="text-amber-400 hover:text-amber-300" href="mailto:support@thedraftlion.com">support@thedraftlion.com</a>.
        </p>
      </Section>
    </div>
  );
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <section className="mt-10">
      <h2 className="text-xl font-bold text-white">{title}</h2>
      <div className="mt-3 text-slate-300 leading-relaxed">{children}</div>
    </section>
  );
}
